// extracted by css-extract-rspack-plugin
export default {"SidebarAside":"Sidebar-module__SidebarAside___N9PJP","ChildrenContainer":"Sidebar-module__ChildrenContainer___z7Mue","ButtonContainer":"Sidebar-module__ButtonContainer___hcStt"};